module.exports = __webpack_public_path__ + "static/img/pallet-half.464abc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pallet-half.jpg
// module id = Kmx9
// module chunks = 1